<template>
  <v-toolbar elevation="0" dense>
    <v-btn @click="handleBackClick" icon small>
      <v-icon small>fa-arrow-left</v-icon>
    </v-btn>
    <v-toolbar-title class="text-wrap">
      <h4 v-if="selectedFaturamentoItensFilterOption === 'todos'">Itens de faturamento</h4>
      <h4 v-else-if="selectedFaturamentoItensFilterOption === 'conciliados'">Itens de faturamento conciliados</h4>
      <h4 v-else-if="selectedFaturamentoItensFilterOption === 'nao-conciliados'">Itens de faturamento não conciliados</h4>
    </v-toolbar-title>
    <v-spacer />
    <conciliacao-faturamento-itens-menu />
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import ConciliacaoFaturamentoItensMenu from './ConciliacaoFaturamentoItensMenu.vue'

export default {
  components: {
    ConciliacaoFaturamentoItensMenu
  },
  computed: {
    ...mapState('conciliacao', ['selectedFaturamentoItensFilterOption'])
  },
  methods: {
    handleBackClick () {
      this.$store.dispatch('conciliacao/backToGuias')
    }
  }
}
</script>
